const resources = {
    freeShipping: 'Free Shipping'
};

module.exports = function getResource(label) {
    return resources[label];
};
